module.exports = __webpack_public_path__ + "img/modelo-cantina-gal-7.253f61f7.jpg";